<div *ngIf="!isStranger()">
  <app-card></app-card>
</div>
<div *ngIf="isStranger()">
  <app-profileStrangers></app-profileStrangers>
</div>
